<template>
  <Head :title="__(title)" />
    <div class="max-w-full bg-white rounded-md shadow overflow-hidden">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                
        <div class="flex items-center justify-end w-full px-8 py-4">
          <loading-button class="border-gray-100 px-8 py-4" style="background-color: #7366ff;color:white;border-radius: 10px;">
            <a :href="import_formate"  target="__blank" download="students.csv">{{ __('Download Import Template') }}</a>
          </loading-button>
        </div>     
        <div class="w-full flex flex-wrap">
          <select-input v-model="form.campus" :error="form.errors.campus" required class="pb-8 pr-6 w-full lg:w-1/3"
            :label="__('Campus')">
            <option :value="null">{{ __('Select Campus') }}</option>
            <option v-for="c in campusOptions" :key="c.value" :value="c.value">{{ c.label }}</option>
          </select-input>
          <select-input v-if="form.campus === 'online'" v-model="form.awarding_body" :error="form.errors.awarding_body"
            required class="pb-8 pr-6 w-full lg:w-1/3" :label="__('Awarding Body')">
            <option :value="null">{{ __('Select Awarding Body') }}</option>
            <option v-for="a in awardingBodyOptions" :key="a.value" :value="a.value">{{ a.label }}</option>
          </select-input>
        </div>
        <div class="w-full">
          <file-input v-model="form.file" :error="form.errors.file" class="pb-8 pr-6 w-6/12 lg:w-1/2" type="file" label="Import File" />
          <loading-button @click="importFile" class="border-gray-100 px-8 py-4 mb-2" style="background-color: #7366ff; color: white; border-radius: 10px;">
            Submit File
          </loading-button>
        </div>
      </div>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'

export default {
  components: {
      SearchInput,
    Head,
    Icon,
    Link,
      Pagination,
      LoadingButton,
      FileInput,
      SelectInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Object,
    import_formate: String,
    campusOptions: Array,
    awardingBodyOptions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        file: null,
        campus: null,
        awarding_body: null,
      }),
    }
  },
  watch: {
    'form.campus'(value) {
      if (value !== 'online') {
        this.form.awarding_body = null
      }
    },
  },
  methods: {
    importFile() {
      if (!this.form.file) {
        alert('Please select a file to upload.');
        return;
      }
      this.form.post(this.route('importStudents'), {
        onSuccess: () => alert('File imported successfully'),
      })
    },
  },
}
</script>

